import React from 'react';

import { Form} from 'react-form';
import Noty from 'noty';
 import { I18n, Trans } from 'react-i18next';



export class Forms extends React.Component {
 
    constructor( props ) {
      super( props );
      this.state = {
     };
    
     this.submitForm=this.submitForm.bind(this)
    }


    submitForm(e) {
      e.preventDefault();
       const t = {I18n,Trans}.t;
      var url='http://hapiwine.fr/api/index.php';

     // console.log(e.target.firstname.value);
      var data={
         firstname:e.target.firstname.value,
         name:e.target.name.value,
         email:e.target.email.value,
         msg:e.target.msg.value,
      }
     console.log(data);
    fetch(url, {
    method: 'POST',
    body: JSON.stringify(data), 
    headers: new Headers({
      'Content-Type': 'application/json',
      //'Access-Control-Allow-Origin': '*',
      
    })
  }).then(res => {

    console.log(res);
    if(res.status == 201) {
      new Noty({
          text: 'Demande soumise avec succès',
          type: 'success',
          killer: true,
          timeout: 1000
      }).show();
      jQuery('form')[0].reset();
    } else {
        new Noty({
          text: 'Erreur',
          type: 'error',
          killer: true,
          timeout: 1000
      }).show();
    }

  })
  .catch(error => {

    new Noty({
        text: 'Erreur lors de la soumission de la demande',
        type: 'error',
        killer: true,
        timeout: 1000
    }).show();

  })
  .then(response => console.log('Success:',response));

    
  }
   
    render() {
    
       return (
        <I18n ns="translations">
        {
          (t, { i18n }) => (
       <section id="pros-form-section">
           <div className="card" >
            <Form>
              <form onSubmit={this.submitForm}>
                  <div className="form-group">
                      <input  name="firstname" className="form-control"  placeholder={t('firstname')}/>
                  </div>
                  <div className="form-group">
                      <input  name="name" className="form-control"  placeholder={t('name')}/>
                  </div>
                  <div className="form-group">
                      <input  name="email" type="email" className="form-control"  placeholder={t('email')}/>
                  </div>
                  <div className="form-group">
                      <textarea  name="msg" className="form-control"  rows="5" placeholder={t('msg')}></textarea>
                  </div>
                  <div className="form-group text-right">
                    <button type="submit" className="btn btn-default btn-style">{t('submit')}</button>
                  </div>
              </form>
            </Form>
           </div>
       </section>
         )
            }
      </I18n>
      );
    }
  }


























/*import React from 'react';

import { Form, Text, Radio, RadioGroup, TextArea, Checkbox } from 'react-form';
import Noty from 'noty';
import { I18n, Trans } from 'react-i18next';


export class Forms extends React.Component {

    constructor( props ) {
      super( props );
      this.state = {
     
     };

     this.submitForm=this.submitForm.bind(this)
    }


    submitForm(e) {
      e.preventDefault();
      console.log(this.refs);
      var url='http://52.47.184.108/hapiwineApi/public/api/contact';
      var data={
         firstname:this.refs.firstname.value,
         name:this.refs.name.value,
         email:this.refs.email.value,
         msg:this.refs.msg.value,
      }
     console.log(data);
     

	fetch(url, {
	  method: 'POST',
	  body: JSON.stringify(data), 
	  headers: new Headers({
	    'Content-Type': 'application/json',
	    //'Access-Control-Allow-Origin': '*',
	    
	  })
	}).then(res => {

    console.log(res);
    if(res.status == 201) {
      new Noty({
          text: 'Demande soumise avec succès',
          type: 'success',
          killer: true,
          timeout: 1000
      }).show();
      jQuery('form')[0].reset();
    } else {
        new Noty({
          text: 'Erreur',
          type: 'error',
          killer: true,
          timeout: 1000
      }).show();
    }

  })
	.catch(error => {

    new Noty({
        text: 'Erreur lors de la soumission de la demande',
        type: 'error',
        killer: true,
        timeout: 1000
    }).show();

  })
	.then(response => console.log('Success:',response));

    
  }



   
    render() {
    
       return (

        <I18n ns="translations">
        {
          (t, { i18n }) => (
       <section id="pros-form-section">
           <div className="card" >
            <Form>
              <form onSubmit={this.submitForm}>
                  <div className="form-group">
                      <input ref="firstname" required="true" className="form-control"  placeholder={t('firstname')} />
                  </div>
                  <div className="form-group">
                      <input ref="name"   className="form-control" placeholder={t('name')} />
                  </div>
                  <div className="form-group">
                      <input ref="email" required="true" type="email" className="form-control"  placeholder={t('email')} />
                  </div>
                  <div className="form-group">
                      <textarea ref="msg" className="form-control" rows="5" placeholder={t('msg')}></textarea>
                  </div>
                  <div className="form-group text-right">
                    <button type="submit" className="btn btn-default btn-style">{t('submit')}</button>
                  </div>
              </form>
            </Form>
           </div>
       </section>
        )
            }
      </I18n>
      );
    }
  }
*/






// WEBPACK FOOTER //
// ./src/components/Professionnel/Form/Form.js